import { useMemo } from "react";
import { useSelector, useStore } from "react-redux";

import { uploadsSelectors } from "../selectors";

const useBatchUploads = batchId => {
    const store = useStore();

    const { currentView } = useSelector(state => state.selectedBatch);
    const {
        visModActiveIds: allVisModActiveIds,
        visModSavedIds: allVisModSavedIds
    } = useSelector(state => state.uploads);

    const batchVisModActiveIds = useMemo(() => {
        if (!allVisModActiveIds) return [];

        return allVisModActiveIds.filter(id => {
            const uploadData = uploadsSelectors.selectById(
                store.getState(),
                id
            );

            return uploadData.photoBatchId === batchId;
        });
    }, [batchId, allVisModActiveIds]);

    const batchVisModSavedIds = useMemo(() => {
        if (!allVisModSavedIds) return [];

        return allVisModSavedIds.filter(id => {
            const uploadData = uploadsSelectors.selectById(
                store.getState(),
                id
            );

            return uploadData.photoBatchId === batchId;
        });
    }, [batchId, allVisModSavedIds]);

    return {
        visModActiveIds: batchVisModActiveIds,
        visModSavedIds: batchVisModSavedIds,
        currentViewUploadIds:
            currentView === "active"
                ? batchVisModActiveIds
                : batchVisModSavedIds
    };
};

export default useBatchUploads;
